<template>
  <v-dialog :value="true" persistent max-width="620">
    <v-card>
      <v-card-title>Ship Sales Order</v-card-title>
      <v-divider/>
        <div class="pa-4">Select an existing draft Shipment to edit for this Sales Order or create a new one.</div>
        <v-list dense>
          <template v-for="draft of draftShipments">
            <v-list-item @click="edit(draft.id)"><v-icon class="mr-4">mdi-arrow-right</v-icon>Draft {{draft.date | formatDateTime}}</v-list-item>
          </template>
          <v-list-item @click="create()"><v-icon class="mr-4">mdi-arrow-right</v-icon>Create new Shipment</v-list-item>
        </v-list>
      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer></v-spacer>
        <v-btn plain color="primary" @click="$emit('done')">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'SalesSalesOrdersPickShipment',
  props: {
    salesOrder: {type: Object, required: false},
    draftShipments: {type: Array, required: true}
  },
  data() {
    return {
      show: true
    }
  },
  methods: {
    edit(shipmentId) {
      this.$emit('done');
      this.$router.push({name:'SalesShipmentsEdit',params:{shipmentId}});
    },
    create() {
      this.$emit('done');
      this.$router.push({name:'SalesShipmentsEditNew',params:{salesOrderId:this.salesOrder.id}});
    }
  }
}
</script>